export const PendingIcon = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Icon / Check">
			<path
				id="Vector 1"
				d="M3.33398 9.08497L7.83615 13.3333L16.6673 5"
				stroke="#FFBE5C"
				strokeWidth="1.5"
			/>
		</g>
	</svg>
);
